export default "__VITE_ASSET__CB0aM9_q__"